import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { Router } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar'
import { BannerSectionType01Component } from "../../banner-section/banner_section-type01/banner_section-type01.component";
import { MapType01Component } from "../../map/map-type01/map-type01.component";
import { BranchSelectorComponent } from "app/mock-api/common/branch-selector/branch-selector.component";
import { Province, Branches } from 'app/mock-api/common/branch-selector/branch';

@Component({
    selector: 'app-contact-type02',
    standalone: true,
    imports: [
        MatIconModule,
        FuseCardComponent,
        NgStyle,
        GoogleMapsModule,
        FormsModule,
        NgClass,
        BannerSectionType01Component,
        MapType01Component,
        BranchSelectorComponent
    ],
    templateUrl: './contact-type02.component.html',
    styleUrl: './contact-type02.component.scss',
})
export class ContactType02Component implements OnInit {
    provinces: Province[] = Branches;
    branchLocations: { lat: number; lng: number; title: string }[] = [];

    public view: any = {
        title: 'Contact Us',
        defaultLat: -26.184083203064613,
        defaultLng: 28.105546154995345,
        locations: [{ lat: -26.101773364687926, lng: 28.054622358370352 }], //XL Head Office
        xlfswmLocation: [{ lat: -25.90696446465186, lng: 29.26773638335561 }], //XL Witbank
        actLocation: [{ lat: -26.134152550925688, lng: 28.19584172059871 }], //XL Aerocity
        xlstLocation: [{ lat: -33.9363093908538, lng: 18.859533474162564 }], //XL Stellenbosch
        xlatLocation: [{ lat: -32.98175597858882, lng: 27.902542924076613 }], //XL Aloe Travel
        message: {},
        map: {
            maxZoom: 20,
            style: [
                {
                    stylers: [
                        {
                            hue: '#ffb718',
                        },
                        {
                            saturation: 50,
                        },
                    ],
                },
                {
                    featureType: 'water',
                    stylers: [
                        {
                            //"color": "#f0f4f9"
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'administrative.country',
                    elementType: 'labels',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
            ],
        },
    };

    constructor(
        public _tfmService: TFMService,
        private router: Router,
        private _cd: ChangeDetectorRef,
        private _snackBar: MatSnackBar
    ) { }

    isFormValid() {
        let valid = true;

        if (!this.view.message.firstName || !this.view.message.emailAddress)
            valid = false;
        return valid;
    }

    //Submit a message
    sendMessage() {
        this.view.message.isBusy = true;
        this.view.message.dateOfInquiry = new Date().toISOString();

        //create itinerary
        this._tfmService
            .createItin({
                description: this.view.site.name + ' - Contact Us Form',
            })
            .subscribe((res) => {
                localStorage.setItem(
                    this._tfmService.itinIdentifier,
                    res.content.itinerary.guid
                );
                this.view.itin = res;

                this.view.itin.content.itinerary.firstName = this.view.message.firstName;
                this.view.itin.content.itinerary.lastName = this.view.message.lastName;
                this.view.itin.content.itinerary.emailAddress = this.view.message.emailAddress;
                this.view.itin.content.itinerary.phoneNumber = this.view.message.phoneNumber;

                if (this.view.site.id == 146) { //Limit to XLTravel 
                    this._tfmService.addToLMS({
                        "contact": {
                            "firstName": this.view.itin.content.itinerary.firstName,
                            "lastName": this.view.itin.content.itinerary.lastName,
                            "phone": this.view.itin.content.itinerary.phoneNumber,
                            "email": this.view.itin.content.itinerary.emailAddress
                        },
                        "deal": {
                            "title": "Contact Request",
                            "description": this.view.message.comments,
                            "currency": "ZAR",
                            "value": 0
                        }
                    });
                }

                //Send the Updated itinerary
                this._tfmService
                    .filterAndSend(
                        this.view.itin.content.itinerary._links,
                        'edit',
                        this.view.itin.content.itinerary
                    )
                    .subscribe((res) => {
                        let msg = { content: '' };
                        msg.content +=
                            (this.view.message.comments || '') + '\n';

                        //Create message
                        this._tfmService.createMessage(msg).subscribe((res) => {
                            if (res == null) {
                                this.view.message.status =
                                    'Something went wrong' +
                                    ' ' +
                                    'Your Reference number is: ' +
                                    ' ' +
                                    this.view.itin.content.itinerary.reference;
                            } else {
                                this.view.message.status =
                                    'Message Sent Successfully' +
                                    ' ' +
                                    'Your Reference number is: ' +
                                    ' ' +
                                    this.view.itin.content.itinerary.reference;
                                this.showToast(
                                    'Message sent successfully!',
                                    'Close'
                                );
                                //  contactForm.resetForm();
                            }
                            this.view.message.isBusy = false;
                        });
                    });
            });
    }

    showToast(
        message: string,
        action: string = 'Close',
        duration: number = 3000
    ) {
        this._snackBar.open(message, action, {
            duration: duration,
        });
    }

    startSlideshow(): void {
        setInterval(() => {
            const nextIndex = (this.view.currentImageIndex + 1) % this.view.imageHrefs.length;
            const nextImage = this.view.imageHrefs[nextIndex];

            this.fadeToImage(nextImage);
            this.view.currentImageIndex = nextIndex;
        }, 5000);
    }

    fadeToImage(nextImage: string): void {
        const img = new Image();
        img.src = nextImage;

        img.onload = () => {
            if (this.view.activeLayer === 1) {
                this.view.imageLayer2 = nextImage;
                this.view.activeLayer = 2;
            } else {
                this.view.imageLayer1 = nextImage;
                this.view.activeLayer = 1;
            }
            this._cd.detectChanges();
        };
    }

    ngOnInit(): void {
        this.view.locations.forEach((l) => {
            l.lat = Number(l.lat);
            l.lng = Number(l.lng);
        });

        this.branchLocations = this.provinces
            .flatMap(p => p.branches)
            .filter(b => !!b.latitude && !!b.longitude)
            .map(b => ({
                lat: +b.latitude,
                lng: +b.longitude,
                title: b.name
            }));

        console.log('Branch locations:', this.branchLocations);

        this._tfmService.getSite().then(res => {
            this.view.site = res;

            this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
            if (this.view.site?.id === 72) {
                const pin = { lat: -22.578343729512373, lng: 17.09243003898437 };
                this.view.locations = [pin];
                this.view.defaultLat = pin.lat;
                this.view.defaultLng = pin.lng;
            }
            this._tfmService.log(this.view);
        });

        this.view.currentImageIndex = 0;
        this.view.activeLayer = 1;
        this.view.imageLayer1 = ''; // start blank or with a default image
        this.view.imageLayer2 = '';

        this._tfmService.getContentBySection('contact').then((res) => {
            this.view.page = res;
            this._tfmService.log('Check this view.page: ', this.view.page);
            const images = this.view.page?.content?.images;

            if (images && images.length > 0) {
                this.view.imageHrefs = images
                    .map((img: any) => {
                        const viewLink = img._links?.find((link: any) => link.rel === 'view');
                        return viewLink?.href ?? null;
                    })
                    .filter((href: string | null) => href !== null);

                this.view.imageLayer1 = this.view.imageHrefs[0];
                this.startSlideshow();
            }
        });
    }

     get defaultLat() {
        return this.branchLocations[0]?.lat || -30.5595; // fallback SA center
    }

    get defaultLng() {
        return this.branchLocations[0]?.lng || 22.9375;
    }
}
